import { computed, observable } from "mobx";
import { IUser, Origin } from "@lib/common-interfaces";
import { config } from "@root/lib/utils/config";
import { UserSettings } from "./user-settings";
import { Model } from "../../lib";
import { azureSubscriptionStore } from "../../management/stores/azure-subscription-store";
import { AzureSubscription } from "../../management/models/azure-subscription";

export class User extends Model<IUser> implements IUser {
  // Hack for making IUser assignable to IAppOwner
  // which lets App#owner be assignable to IApp['owner']
  public type = "user";
  @observable public id: string;
  @observable public display_name: string;
  @observable public email: string;
  @observable public name: string;
  @observable public avatar_url: string;
  @observable public can_change_password: boolean;
  @observable public admin_role: string;
  @observable public feature_flags: string[];
  @observable public next_nps_survey_date: string;
  @observable public origin: Origin;
  @observable public settings: UserSettings;
  @observable public created_at: string;
  @observable public is_microsoft_internal: String;

  constructor(user: IUser) {
    // Initialize user settings
    super({ ...user, settings: new UserSettings(user.settings || {}) });
  }

  @computed
  get isCreatedInHockeyApp(): boolean {
    return this.origin === Origin.HockeyApp;
  }

  @computed
  get isCreatedInTestCloud(): boolean {
    return this.origin === Origin.TestCloud;
  }

  @computed
  get isCreatedInAppCenter(): boolean {
    return this.origin === Origin.MobileCenter || this.origin === Origin.AppCenter;
  }

  @computed
  get azureSubscriptions(): AzureSubscription[] {
    return azureSubscriptionStore.resources.filter((subscription) => subscription.userId === this.id);
  }

  @computed
  get hockeyAppUrl(): string | undefined {
    if (!this.isCreatedInHockeyApp) {
      console.warn("This user is not created in HockeyApp");
      return undefined;
    }
    return `${config.getHockeyAppRootUrl()}/profiles/me/edit`;
  }
}
